// DO NOT EDIT - THIS FILE IS AUTOGENERATED
// To change this file, change the relevant feature flags spec YAML file and re-run the following generator:
//   make gen-flags && gen-flags

import { FstaFlags } from './goimports/fs_featureflags_fsta';

export const FstaFlagDefaults: Readonly<FstaFlags> = {
  AppAdvancedPermissionsSpaces: false,
  AppAiPageExplorations: false,
  AppAiPageSuggestions: false,
  AppAiPageSuggestionsFeedback: false,
  AppAiSuggestionsExplorations: false,
  AppAiSummaryModel: "v2_gemini_few_shot",
  AppAnswersDebugMode: false,
  AppAnswersUi: false,
  AppAppcues: false,
  AppAutoWatchErrorAndLoadingIndicators: false,
  AppBlockNotificationsForSeat: "no-users",
  AppCapturedEventsViewer: false,
  AppCapturedEventsViewerAllTypes: false,
  AppClassificationRules: false,
  AppClassificationSearch: false,
  AppClickmapPossibleElementsHighlighting: false,
  AppCompleteSessionsConstraint: false,
  AppContextualOmnibox: "disabled",
  AppConversionHeatmapsGroupByProperty: false,
  AppConversionMapBetaTag: false,
  AppConversionMapLandingPage: false,
  AppConversionMapNativeMobile: false,
  AppConversionMapNewTag: false,
  AppConversionsFsSpecSignal: false,
  AppConversionsPageviewSignal: false,
  AppConversionsSignificantDimensions: false,
  AppConversionsSplitWebVitals: false,
  AppCrossOrgRedirect: false,
  AppCustomSegmentNaming: false,
  AppDarkMode: false,
  AppDarkModeBetaTag: true,
  AppDataPlan: false,
  AppDataStudioElementPropertyRules: false,
  AppDataStudioTips: false,
  AppDataTables: false,
  AppDataTablesCards: false,
  AppDataTablesFunnels: false,
  AppDatalossUseCustomPerformanceTimeranges: "default",
  AppDatatablesCustomProperties: false,
  AppDatatablesMultiSegments: false,
  AppDatePickerAlternateOptions: false,
  AppDatePickerTimeInputs: false,
  AppDateRangeMaxLength: 0,
  AppDefinedEventWebhooks: false,
  AppDefinedEventsCooked: false,
  AppDefinedEventsEventList: false,
  AppDefinedEventsJourneys: false,
  AppDefinedEventsOrLimit: 10,
  AppDependentUserFilters: false,
  AppDetectionsEventSourceError: false,
  AppDetectionsEventSourceLog: false,
  AppDetectionsEventSourceNavigate: false,
  AppDetectionsEventSourceNetwork: false,
  AppDisplayElementEventLimits: false,
  AppDomainCaptureGuard: false,
  AppDqmProperties: false,
  AppDualMeasureDimensionApplicationOptions: false,
  AppDxCleanupPrototype: false,
  AppDxObjectTableFiltersV2: false,
  AppEditTargetedMobilePrivacyRules: false,
  AppEditTargetedMobileRecordingRules: false,
  AppElementPropertiesRegexValue: false,
  AppElementPropertyRulesV2: false,
  AppElementsAuditLog: false,
  AppEmailDetectionEvents: false,
  AppEnableRulesetExceptions: false,
  AppEqualsMaxOrs: 500,
  AppErrorStateVisible: false,
  AppEventFiltersDropdownCategoriesAndDescriptions: false,
  AppEventThresholds: false,
  AppExpandedHourly: false,
  AppExperimentationEnabled: false,
  AppFsAnywhereActivations: false,
  AppFsAnywhereCallout: false,
  AppFsSdkVersion: false,
  AppFsSpec: false,
  AppFsSpecAi: false,
  AppFsevtRealtime: false,
  AppFunnelDimensionApplicationOptions: false,
  AppGlidePaths: false,
  AppGlobalFilters: false,
  AppGravatarProfiles: true,
  AppGroupManagement: false,
  AppHeatmapExportPinViewportCss: false,
  AppHeatmapsClickAreaOverlays: false,
  AppHeatmapsConversions: false,
  AppHeatmapsFocusContainerOnly: false,
  AppHeatmapsGroupByProperty: false,
  AppHeatmapsMinPageviewDurationMillis: 0,
  AppHeatmapsNmRepresentativePageDistance: 100,
  AppHeatmapsPageVarQueryEnhancement: false,
  AppHeatmapsWebRepresentativePageDistance: 100,
  AppHideDeprecatedElementSettings: false,
  AppHourlyUseDayLabels: false,
  AppInNextCustomDates: false,
  AppIntlGermanLanguage: false,
  AppIntlPseudoLanguage: false,
  AppJourneysBackgroundClickClearsFilters: false,
  AppJourneysContext: false,
  AppLlmChat: false,
  AppLlmInternalTools: false,
  AppLongTaskEvents: false,
  AppMaxRerenderOnGoogleTranslateError: -1,
  AppMeasureDataStudio: false,
  AppMergedPageSupport: false,
  AppMetricsDimensionalityExplore: false,
  AppMetricsUniqueProperty: false,
  AppMoreOnboardingInstallOptions: false,
  AppMostRecentSession: false,
  AppMultiValueExtractedProperties: false,
  AppMultiplayer: false,
  AppNativeMobileClickMaps: false,
  AppNativeMobileClickMapsBetaTag: false,
  AppNativeMobileClickMapsNewBadge: false,
  AppNewFstaColors: false,
  AppNewSessionPlaylistUi: false,
  AppObjectPickerForElements: false,
  AppObjectPickerPrototype: false,
  AppObjectReferences: false,
  AppObjectReferencesEvents: false,
  AppObjectReferencesPages: false,
  AppOmniboxNavigation: true,
  AppPageDefinitionQueryParams: false,
  AppPageFragmentGrouping: false,
  AppPlaybackDeepLinkSeekStartTimeBypass: false,
  AppPlaybackDisableResourceCacheLockOnRead: false,
  AppPlaybackEnableSvgHrefWorkaround: true,
  AppPlaybackFirstInsertWhenRefactor: false,
  AppPlaybackFloatingViewportMode: false,
  AppPlaybackGcsFetchFallbacks: false,
  AppPlaybackLazyCookedPageFetching: false,
  AppPlaybackMinimizeFouc: false,
  AppPlaybackPagePlaybackReactMigration: false,
  AppPlaybackPlayPauseSeekShortcuts: false,
  AppPlaybackPlaybackContextCaching: false,
  AppPlaybackReifyNodeLimit: true,
  AppPlaybackRendererAccessibleTouchColorChange: false,
  AppPlaybackRendererHostRecordCustomEvents: false,
  AppPlaybackResourceMapShrinking: false,
  AppPlaybackSeekEventSampleThreshold: 50,
  AppPlaybackSeekShortcuts: false,
  AppPlaybackSharedWorker: false,
  AppPlaybackSrcsetDescriptorsSupport: false,
  AppPlaybackUseLayoutViewport: false,
  AppPlaybackViewportMetaScrollFix: false,
  AppPreventDuplicateDefinedEvents: false,
  AppPrivacyLayoutV2: false,
  AppPrivateObjectsSidebar: false,
  AppPwdDetectionEvents: false,
  AppRawSessionDataOnBulkSummary: false,
  AppReadOnlyDataStudio: false,
  AppScimUi: false,
  AppSearchBackgrounded: false,
  AppSegmentDataDestinations: false,
  AppSegmentDxCards: false,
  AppSegmentExcludeConstraints: false,
  AppSelectorDebug: false,
  AppSelfServeSso: false,
  AppSessionAssistantChat: false,
  AppSessionSummaryOnHover: false,
  AppSessionType: false,
  AppSettingsLabsSettingsPage: false,
  AppSettingsStripePrices: true,
  AppShowBlockRuleExceptionsForMobileOrgs: false,
  AppShowBlockedAttributes: false,
  AppShowFocusSignal: false,
  AppShowFormPrivacyWithPbdEnabled: false,
  AppShowMlToggle: false,
  AppSideBySideLayout: false,
  AppSignalStudioMetricsSidebar: false,
  AppSingleApiErrorFilter: false,
  AppSpec1ToNAndProperties: false,
  AppSpecDx: false,
  AppSpecDxAccount: false,
  AppSplitProcessingPack: false,
  AppSpotlight: false,
  AppSpotlightFunnelSideBySideChart: false,
  AppSpotlightFunnels: false,
  AppSpotlightOverviewTab: false,
  AppSpotlightSidenav: false,
  AppSpotlightSilenceIssues: false,
  AppSpotlightSpikingIssuesFunnels: false,
  AppStagingBugReports: false,
  AppSuggestedElements: false,
  AppSuggestedElementsSpec: false,
  AppSummaryTags: false,
  AppSuspiciousActivitySearch: false,
  AppTargetedPrivacyRulesets: false,
  AppTemplateGalleryWebCaptureConfiguration: false,
  AppTopLevelDataStudio: false,
  AppTrendsMinutely: false,
  AppUnmappedSpecSuggestions: false,
  AppUnmaskAssetsMobileToggle: false,
  AppUrlExactPathOperators: false,
  AppUrlPrivacy: false,
  AppUseMultiArchive: false,
  AppVectorOmnisuggest: false,
  AppVirtualDashboardFilters: false,
  AppVirtualDashboards: false,
  AppWarehouseSettingsRedshiftSchema: false,
  AppWarehouseSettingsSnowflakeSchema: false,
  AppWithinTimeConstraint: false,
  PaigeCaseInsensitiveMatching: false,
  ThumbnailsGcfExtraLogging: false,
};

export const FstaFlagTypes: { readonly [Flag in keyof FstaFlags]: string } = {
  AppAdvancedPermissionsSpaces: "boolean",
  AppAiPageExplorations: "boolean",
  AppAiPageSuggestions: "boolean",
  AppAiPageSuggestionsFeedback: "boolean",
  AppAiSuggestionsExplorations: "boolean",
  AppAiSummaryModel: "string",
  AppAnswersDebugMode: "boolean",
  AppAnswersUi: "boolean",
  AppAppcues: "boolean",
  AppAutoWatchErrorAndLoadingIndicators: "boolean",
  AppBlockNotificationsForSeat: "string",
  AppCapturedEventsViewer: "boolean",
  AppCapturedEventsViewerAllTypes: "boolean",
  AppClassificationRules: "boolean",
  AppClassificationSearch: "boolean",
  AppClickmapPossibleElementsHighlighting: "boolean",
  AppCompleteSessionsConstraint: "boolean",
  AppContextualOmnibox: "string",
  AppConversionHeatmapsGroupByProperty: "boolean",
  AppConversionMapBetaTag: "boolean",
  AppConversionMapLandingPage: "boolean",
  AppConversionMapNativeMobile: "boolean",
  AppConversionMapNewTag: "boolean",
  AppConversionsFsSpecSignal: "boolean",
  AppConversionsPageviewSignal: "boolean",
  AppConversionsSignificantDimensions: "boolean",
  AppConversionsSplitWebVitals: "boolean",
  AppCrossOrgRedirect: "boolean",
  AppCustomSegmentNaming: "boolean",
  AppDarkMode: "boolean",
  AppDarkModeBetaTag: "boolean",
  AppDataPlan: "boolean",
  AppDataStudioElementPropertyRules: "boolean",
  AppDataStudioTips: "boolean",
  AppDataTables: "boolean",
  AppDataTablesCards: "boolean",
  AppDataTablesFunnels: "boolean",
  AppDatalossUseCustomPerformanceTimeranges: "string",
  AppDatatablesCustomProperties: "boolean",
  AppDatatablesMultiSegments: "boolean",
  AppDatePickerAlternateOptions: "boolean",
  AppDatePickerTimeInputs: "boolean",
  AppDateRangeMaxLength: "number",
  AppDefinedEventWebhooks: "boolean",
  AppDefinedEventsCooked: "boolean",
  AppDefinedEventsEventList: "boolean",
  AppDefinedEventsJourneys: "boolean",
  AppDefinedEventsOrLimit: "number",
  AppDependentUserFilters: "boolean",
  AppDetectionsEventSourceError: "boolean",
  AppDetectionsEventSourceLog: "boolean",
  AppDetectionsEventSourceNavigate: "boolean",
  AppDetectionsEventSourceNetwork: "boolean",
  AppDisplayElementEventLimits: "boolean",
  AppDomainCaptureGuard: "boolean",
  AppDqmProperties: "boolean",
  AppDualMeasureDimensionApplicationOptions: "boolean",
  AppDxCleanupPrototype: "boolean",
  AppDxObjectTableFiltersV2: "boolean",
  AppEditTargetedMobilePrivacyRules: "boolean",
  AppEditTargetedMobileRecordingRules: "boolean",
  AppElementPropertiesRegexValue: "boolean",
  AppElementPropertyRulesV2: "boolean",
  AppElementsAuditLog: "boolean",
  AppEmailDetectionEvents: "boolean",
  AppEnableRulesetExceptions: "boolean",
  AppEqualsMaxOrs: "number",
  AppErrorStateVisible: "boolean",
  AppEventFiltersDropdownCategoriesAndDescriptions: "boolean",
  AppEventThresholds: "boolean",
  AppExpandedHourly: "boolean",
  AppExperimentationEnabled: "boolean",
  AppFsAnywhereActivations: "boolean",
  AppFsAnywhereCallout: "boolean",
  AppFsSdkVersion: "boolean",
  AppFsSpec: "boolean",
  AppFsSpecAi: "boolean",
  AppFsevtRealtime: "boolean",
  AppFunnelDimensionApplicationOptions: "boolean",
  AppGlidePaths: "boolean",
  AppGlobalFilters: "boolean",
  AppGravatarProfiles: "boolean",
  AppGroupManagement: "boolean",
  AppHeatmapExportPinViewportCss: "boolean",
  AppHeatmapsClickAreaOverlays: "boolean",
  AppHeatmapsConversions: "boolean",
  AppHeatmapsFocusContainerOnly: "boolean",
  AppHeatmapsGroupByProperty: "boolean",
  AppHeatmapsMinPageviewDurationMillis: "number",
  AppHeatmapsNmRepresentativePageDistance: "number",
  AppHeatmapsPageVarQueryEnhancement: "boolean",
  AppHeatmapsWebRepresentativePageDistance: "number",
  AppHideDeprecatedElementSettings: "boolean",
  AppHourlyUseDayLabels: "boolean",
  AppInNextCustomDates: "boolean",
  AppIntlGermanLanguage: "boolean",
  AppIntlPseudoLanguage: "boolean",
  AppJourneysBackgroundClickClearsFilters: "boolean",
  AppJourneysContext: "boolean",
  AppLlmChat: "boolean",
  AppLlmInternalTools: "boolean",
  AppLongTaskEvents: "boolean",
  AppMaxRerenderOnGoogleTranslateError: "number",
  AppMeasureDataStudio: "boolean",
  AppMergedPageSupport: "boolean",
  AppMetricsDimensionalityExplore: "boolean",
  AppMetricsUniqueProperty: "boolean",
  AppMoreOnboardingInstallOptions: "boolean",
  AppMostRecentSession: "boolean",
  AppMultiValueExtractedProperties: "boolean",
  AppMultiplayer: "boolean",
  AppNativeMobileClickMaps: "boolean",
  AppNativeMobileClickMapsBetaTag: "boolean",
  AppNativeMobileClickMapsNewBadge: "boolean",
  AppNewFstaColors: "boolean",
  AppNewSessionPlaylistUi: "boolean",
  AppObjectPickerForElements: "boolean",
  AppObjectPickerPrototype: "boolean",
  AppObjectReferences: "boolean",
  AppObjectReferencesEvents: "boolean",
  AppObjectReferencesPages: "boolean",
  AppOmniboxNavigation: "boolean",
  AppPageDefinitionQueryParams: "boolean",
  AppPageFragmentGrouping: "boolean",
  AppPlaybackDeepLinkSeekStartTimeBypass: "boolean",
  AppPlaybackDisableResourceCacheLockOnRead: "boolean",
  AppPlaybackEnableSvgHrefWorkaround: "boolean",
  AppPlaybackFirstInsertWhenRefactor: "boolean",
  AppPlaybackFloatingViewportMode: "boolean",
  AppPlaybackGcsFetchFallbacks: "boolean",
  AppPlaybackLazyCookedPageFetching: "boolean",
  AppPlaybackMinimizeFouc: "boolean",
  AppPlaybackPagePlaybackReactMigration: "boolean",
  AppPlaybackPlayPauseSeekShortcuts: "boolean",
  AppPlaybackPlaybackContextCaching: "boolean",
  AppPlaybackReifyNodeLimit: "boolean",
  AppPlaybackRendererAccessibleTouchColorChange: "boolean",
  AppPlaybackRendererHostRecordCustomEvents: "boolean",
  AppPlaybackResourceMapShrinking: "boolean",
  AppPlaybackSeekEventSampleThreshold: "number",
  AppPlaybackSeekShortcuts: "boolean",
  AppPlaybackSharedWorker: "boolean",
  AppPlaybackSrcsetDescriptorsSupport: "boolean",
  AppPlaybackUseLayoutViewport: "boolean",
  AppPlaybackViewportMetaScrollFix: "boolean",
  AppPreventDuplicateDefinedEvents: "boolean",
  AppPrivacyLayoutV2: "boolean",
  AppPrivateObjectsSidebar: "boolean",
  AppPwdDetectionEvents: "boolean",
  AppRawSessionDataOnBulkSummary: "boolean",
  AppReadOnlyDataStudio: "boolean",
  AppScimUi: "boolean",
  AppSearchBackgrounded: "boolean",
  AppSegmentDataDestinations: "boolean",
  AppSegmentDxCards: "boolean",
  AppSegmentExcludeConstraints: "boolean",
  AppSelectorDebug: "boolean",
  AppSelfServeSso: "boolean",
  AppSessionAssistantChat: "boolean",
  AppSessionSummaryOnHover: "boolean",
  AppSessionType: "boolean",
  AppSettingsLabsSettingsPage: "boolean",
  AppSettingsStripePrices: "boolean",
  AppShowBlockRuleExceptionsForMobileOrgs: "boolean",
  AppShowBlockedAttributes: "boolean",
  AppShowFocusSignal: "boolean",
  AppShowFormPrivacyWithPbdEnabled: "boolean",
  AppShowMlToggle: "boolean",
  AppSideBySideLayout: "boolean",
  AppSignalStudioMetricsSidebar: "boolean",
  AppSingleApiErrorFilter: "boolean",
  AppSpec1ToNAndProperties: "boolean",
  AppSpecDx: "boolean",
  AppSpecDxAccount: "boolean",
  AppSplitProcessingPack: "boolean",
  AppSpotlight: "boolean",
  AppSpotlightFunnelSideBySideChart: "boolean",
  AppSpotlightFunnels: "boolean",
  AppSpotlightOverviewTab: "boolean",
  AppSpotlightSidenav: "boolean",
  AppSpotlightSilenceIssues: "boolean",
  AppSpotlightSpikingIssuesFunnels: "boolean",
  AppStagingBugReports: "boolean",
  AppSuggestedElements: "boolean",
  AppSuggestedElementsSpec: "boolean",
  AppSummaryTags: "boolean",
  AppSuspiciousActivitySearch: "boolean",
  AppTargetedPrivacyRulesets: "boolean",
  AppTemplateGalleryWebCaptureConfiguration: "boolean",
  AppTopLevelDataStudio: "boolean",
  AppTrendsMinutely: "boolean",
  AppUnmappedSpecSuggestions: "boolean",
  AppUnmaskAssetsMobileToggle: "boolean",
  AppUrlExactPathOperators: "boolean",
  AppUrlPrivacy: "boolean",
  AppUseMultiArchive: "boolean",
  AppVectorOmnisuggest: "boolean",
  AppVirtualDashboardFilters: "boolean",
  AppVirtualDashboards: "boolean",
  AppWarehouseSettingsRedshiftSchema: "boolean",
  AppWarehouseSettingsSnowflakeSchema: "boolean",
  AppWithinTimeConstraint: "boolean",
  PaigeCaseInsensitiveMatching: "boolean",
  ThumbnailsGcfExtraLogging: "boolean",
};
